import React from "react";
import { Card, Box } from "@bca/ui-library";

import BuyNowContent from "./BuyNowContent";

interface BuyNowCardProps {
  buyNowAmount: number;
  onBuy: () => void;
}

const BuyNowCard: React.FunctionComponent<BuyNowCardProps> = (props) => {
  return (
    <Box
      width={{ mobile: "100%", tablet: "100%", desktop: "50%" }}
      css={`
        @media screen and (min-width: 769px) and (max-width: 950px) {
          width: 70%;
        }
      `}
    >
      <Card
        width="100%"
        height={"auto"}
        paddingX={28}
        paddingY={28}
        marginX={0}
        marginY={[3, 7, 0]}
      >
        <BuyNowContent {...props} layout="BuyNow" />
      </Card>
    </Box>
  );
};

export default BuyNowCard;
